import {SpUiConfigService} from '../services/sp-ui-config.service';
import {unsafeCSS} from "lit";
import {CSSResult} from "@lit/reactive-element/css-tag";

export const getIcon = (name: SpIconName, options?: SpIconOptions) =>  {
    const _options = {
        color: 'white',
        size: 'svg',
        ...options
    }
    return `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/${_options.color}/${_options.size}/${name}.${ _options.size === 'svg' ? 'svg' : 'png' }`
}

export const unsafeCSSIcon = (name: SpIconName, options?: SpIconOptions): CSSResult => {
    return unsafeCSS(getIcon(name, options));
}

export interface SpIconOptions {
    color?: SpIconColor;
    size?: SpIconSize;
}
export type SpIconColor = 'grey-light' | 'grey-medium' | 'grey-dark' | 'grey-dark-filled' | 'white' | 'colored';
export type SpIconSize = 'x16' | 'x64' | 'x128' | 'x256' | 'svg';
export type SpIconName =
    'abort' |
    'ai' |
    'alert' |
    'angle-left' |
    'angle-left-thin' |
    'angle-right' |
    'angle-right-thin' |
    'arrow' |
    'arrow-circle-o-down' |
    'bars' |
    'bar-chart' |
    'bell' |
    'binoculars' |
    'book' |
    'bookmark' |
    'briefcase' |
    'calendar' |
    'camera' |
    'check' |
    'checkmark-circle' |
    'checkmark-circle-border' |
    'clock' |
    'close' |
    'close-thin' |
    'comment' |
    'comment-o' |
    'compass' |
    'clock-o' |
    'crosshair' |
    'crown' |
    'dot' |
    'download' |
    'ellipsis-h-circle' |
    'ellipsis-h-square' |
    'ellipsis-v-square' |
    'envelope' |
    'exit' |
    'eye' |
    'eye-slash' |
    'filter' |
    'filter-close' |
    'flag' |
    'flashlight' |
    'folder' |
    'gear' |
    'gps' |
    'heart' |
    'heart-o' |
    'home' |
    'hourglass' |
    'image' |
    'image-target' |
    'info-circle' |
    'intro' |
    'key' |
    'line-chart' |
    'list-detail' |
    'lock' |
    'marker-plus' |
    'medal' |
    'mention' |
    'microphone' |
    'minus-square' |
    'minus-tiny' |
    'pause' |
    'pencil' |
    'pencil-crown' |
    'play' |
    'plus' |
    'plus-circle' |
    'plus-square' |
    'plus-tiny' |
    'quote' |
    'refresh' |
    'reply' |
    'resume' |
    'retry' |
    'rotate-right-circle' |
    'search' |
    'share' |
    'spotteron' |
    'stack' |
    'star' |
    'star-gold' |
    'star-silver' |
    'star-bronze' |
    'trash' |
    'trash-circle' |
    'university' |
    'user' |
    'user-check' |
    'user-plus' |
    'warning';

/*
export const greylight_16_stack = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x16/stack.png`;

export const greylight_64_clockO = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x64/clock-o.png`;
export const greylight_64_star = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x64/star.png`;
export const greylight_64_dot = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x64/dot.png`;
export const greylight_64_folder = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x64/folder.png`;
export const greylight_64_quote = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x64/quote.png`;

export const greylight_128_book = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x128/book.png`;
export const greylight_128_bookmark = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x128/bookmark.png`;
export const greylight_128_briefcase = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x128/briefcase.png`;
export const greylight_128_close = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x128/close.png`;
export const greylight_128_closeThin = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x128/close-thin.png`;
export const greylight_128_comment = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x128/comment.png`;
export const greylight_128_compass = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x128/compass.png`;
export const greylight_128_flag = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x128/flag.png`;
export const greylight_128_flashlight = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x128/flashlight.png`;
export const greylight_128_heart = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x128/heart.png`;
export const greylight_128_home = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x128/home.png`;
export const greylight_128_spotteron = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x128/spotteron.png`;
export const greylight_128_star = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x128/star.png`;
export const greylight_128_university = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x128/university.png`;
export const greylight_128_user = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x128/user.png`;
export const greylight_128_quote = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x128/quote.png`;

export const greylight_256_imageTarget = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-light/x256/image-target.png`;

export const greymedium_128_share = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-medium/x128/share.png`;
export const greymedium_128_ellipsisVSquare = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-medium/x128/ellipsis-v-square.png`;
export const greydark_128_angleRightThin = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/angle-right-thin.png`;
export const greydark_128_arrowCircleODown = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/arrow-circle-o-down.png`;
export const greydark_128_barChart = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/bar-chart.png`;
export const greydark_128_binoculars = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/binoculars.png`;
export const greydark_128_clock = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/clock.png`;
export const greydark_128_commentO = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/comment-o.png`;
export const greydark_128_crosshair = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/crosshair.png`;
export const greydark_128_download = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/download.png`;
export const greydark_128_ellipsisVSquare = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/ellipsis-v-square.png`;
export const greydark_128_ellipsisHCircle = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/ellipsis-h-circle.png`;
export const greydark_128_envelope = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/envelope.png`;
export const greydark_128_exit = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/exit.png`;
export const greydark_128_filter = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/filter.png`;
export const greydark_128_flag = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/flag.png`;
export const greydark_128_gear = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/gear.png`;
export const greydark_128_heartO = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/heart-o.png`;
export const greydark_128_infoCircle = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/info-circle.png`;
export const greydark_128_intro = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/intro.png`;
export const greydark_128_key = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/key.png`;
export const greydark_128_listDetail = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/list-detail.png`;
export const greydark_128_markerPlus = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/marker-plus.png`;
export const greydark_128_plus = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/plus.png`;
export const greydark_128_reply = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/reply.png`;
export const greydark_128_search = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/search.png`;
export const greydark_128_share = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/share.png`;
export const greydark_128_trash = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/trash.png`;
export const greydark_128_user = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/user.png`;
export const greydark_128_userPlus = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/user-plus.png`;
export const greydark_128_warning = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/x128/warning.png`;

export const greydark_svg_abort = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/svg/abort.svg`;
export const greydark_svg_microphone = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/svg/microphone.svg`;
export const greydark_svg_pause = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/svg/pause.svg`;
export const greydark_svg_hourglass = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/svg/hourglass.svg`;
export const greydark_svg_resume = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/svg/resume.svg`;
export const greydark_svg_retry = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/svg/retry.svg`;
export const greydark_svg_check = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/svg/check.svg`;
export const greydark_svg_eye = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark/svg/eye.svg`;

export const greydark_filled_128_plusSquare = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark-filled/x128/plus-square.png`;
export const greydark_filled_128_minusSquare = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark-filled/x128/minus-square.png`;
export const greydark_filled_128_rotateRightCircle = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark-filled/x128/rotate-right-circle.png`;
export const greydark_filled_128_trashCircle = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/grey-dark-filled/x128/trash-circle.png`;

export const white_64_angle_left = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x64/angle-left.png`;
export const white_64_angle_right = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x64/angle-right.png`;

export const white_128_alert = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/alert.png`;
export const white_128_camera = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/camera.png`;
export const white_128_check = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/check.png`;
export const white_128_crown = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/crown.png`
export const white_128_ellipsisHSquare = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/ellipsis-h-square.png`
export const white_128_ellipsisVSquare = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/ellipsis-v-square.png`;
export const white_128_listDetail = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/list-detail.png`;
export const white_128_medal = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/medal.png`;
export const white_128_pencil = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/pencil.png`;
export const white_128_pencilCrown = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/pencil-crown.png`;
export const white_128_spotteron = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/spotteron.png`;
export const white_128_user = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/user.png`;
export const white_128_userCheck = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/user-check.png`;
export const white_128_userPlus = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/user-plus.png`;
export const white_128_plus = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/plus.png`;
export const white_128_markerPlus = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/marker-plus.png`;
export const white_128_bell = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/bell.png`;
export const white_128_clock = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/clock.png`;
export const white_128_envelope = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/envelope.png`;
export const white_128_barChart = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/bar-chart.png`;
export const white_128_filter = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/filter.png`;
export const white_128_filterClose = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/filter-close.png`;
export const white_128_binoculars = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/binoculars.png`;
export const white_128_gps = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/gps.png`;
export const white_128_infoCircle = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/info-circle.png`;
export const white_128_key = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/key.png`;
export const white_128_close = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/close.png`;
export const white_128_bars = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/bars.png`;
export const white_128_lock = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/lock.png`;
export const white_128_image = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/image.png`;
export const white_128_comment = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/comment.png`;
export const white_128_minusTiny = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/minus-tiny.png`;
export const white_128_plusTiny = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/plus-tiny.png`;
export const white_128_play = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/play.png`;
export const white_128_pause = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/pause.png`;
export const white_128_calendar = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/calendar.png`;
export const white_128_angleLeftThin = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/angle-left-thin.png`;
export const white_128_search = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/search.png`;
export const white_128_refresh = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/x128/refresh.png`;

export const white_svg_microphone = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/svg/microphone.svg`;
export const white_svg_pause = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/svg/pause.svg`;
export const white_plus_circle = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/svg/plus-circle.svg`;
export const white_arrow = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/svg/arrow.svg`;
export const white_ai = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/white/svg/ai.svg`;

export const colored_128_comment = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/colored/x128/comment.png`;
export const colored_128_heart = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/colored/x128/heart.png`;
export const colored_128_mention = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/colored/x128/mention.png`;
export const colored_128_star = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/colored/x128/star.png`;
export const colored_128_checkmarkCircleBorder = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/colored/x128/checkmark-circle-border.png`;
export const colored_128_checkmarkCircle = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/colored/x128/checkmark-circle.png`;

export const colored_256_spotteron = `${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/icon/colored/x256/spotteron.png`;
*/
